module.exports = __webpack_public_path__ + "img/1567069791.6a0187d5.jpg";